<template>
  <form class="login" @submit.prevent="login">
    <login-card header-color="green">
      <h4 slot="title" class="card-title">Вход</h4>

      <error slot="description" :errors="errors"/>

      <md-field class="md-form-group" slot="inputs" v-for="(input, key) in auth" :key="key">
        <md-icon>{{ input.icon }}</md-icon>
        <label>{{ input.label }}</label>
        <md-input v-model="input.value" :type="input.type"></md-input>
      </md-field>
      <md-button slot="inputs" class="md-success m-2 col-10" type="submit">
        Ок
      </md-button>
      <md-button slot="inputs" class="md-success m-2 col-10" @click="$emit('changeForm')">
        Регистрация
      </md-button>
      <md-button slot="inputs" class="md-success m-2 col-10" @click="$emit('resetPassword')">
        Востановить пароль
      </md-button>

    </login-card>
  </form>
</template>

<script>

import { mapActions } from 'vuex'
import { LoginCard } from "@/components"
import Error from "./Error"

export default {
  name: "Login",
  components: {LoginCard, Error},
  data(){
    return {
      auth: {
        login: {
          label: 'Логин',
          value: '',
          type: 'text',
          icon: 'account_circle',
        },
        password: {
          label: 'Пароль',
          value: '',
          type: 'password',
          icon: 'password',
        }
      },
      errors: []
    }
  },
  methods: {
    ...mapActions(["auth/login"]),
    login() {
      let login = this.auth.login.value;
      let password = this.auth.password.value;
      this.$store.dispatch('auth/login', { login, password })

          .then((resp) => {
            if (resp.data.message === 'Ожидайте подтверждение администратором!') {
              this.errors.push(resp.data);
            }else{
              this.$router.push('/color');
              location.reload();
            }
          })
          .catch(err => {
              this.errors = [];
              if(err.message === 'The given data was invalid.') {
                  for (let i in err.errors) {
                    for (let j in err.errors[i]) {
                      this.errors.push(err.errors[i][j]);
                    }
                }
              } else {
                this.errors.push(err.message);
              }
          })
    }
    }
  }

</script>

<style scoped>

</style>